import { useQuery } from 'react-query';

import { axios, axiosWithoutInterceptors } from '@/lib/axios';

export function useGetReferentialsAsync<TData>(
  pathname: string,
  {
    onSuccess,
    isEnabled,
    isAnonymous,
  }: { onSuccess?: (data: TData) => void; isEnabled?: boolean; isAnonymous?: boolean } = {},
) {
  return useQuery({
    enabled: isEnabled,
    staleTime: Infinity,
    queryKey: [pathname],
    queryFn: async () => {
      const { data } = isAnonymous
        ? await axiosWithoutInterceptors.get<TData>(pathname)
        : await axios.get<TData>(pathname);
      return data;
    },
    onSuccess,
  });
}
